export enum RoutePaths {
  ShortageOverview = 'shortage-overview',
  FAQ = 'faq',
  Verify = 'verify',
  Users = 'users',
  ConectafarmLogin = 'conectafarm-login',
  LanguageSelection = 'language-selection',
  Login = 'login',
  RXLogin = 'rx-login',
  MySandozLogin = 'mysandoz/validate',
  Register = 'register',
  ForgotPassword = 'forgot-password',
  ResetPassword = 'reset-password',
  ExpiredPassword = 'expired-password',
  CountrySelection = 'country-selection',
  errorServer = 'server-error',
  UnsubscribeMail = 'unsubscribe-mail',
}
